import styled from 'styled-components';
import {Link} from 'react-router-dom';

export const Wrapper = styled.div`
  display: inline-block;
  margin-left: 10px;
  position: relative;
  
  @media screen and (min-width: 992px) {
    margin-left: 22px;
  }
`

export const IconContainer = styled.div`
  cursor: pointer;
  position: relative;
`

export const NotifyIcon = styled.img`
  height: 25px;
  width: 20px;
`

export const Notify = styled.div`
  display: inline-block;
  
  height: 10px;
`

export const RedDot = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 5px;
  background-color: #EB5757;
  display: inline-block;
  vertical-align: middle;
  &.top-position{
    position: absolute;
    top: 2px;
    right: 0px;
  }
`

export const DropContainer = styled.div`
  position: absolute;
  z-index: 1000;
  top: 40px;
  right: 0;
  width: 0;
  height: auto;
  border-radius: 10px;
  max-height: 440px;
  transform: scaleY(0);
  transform-origin: top;
  overflow: auto;
  background-color: #fff;
  transition: ease-in-out 0.1s;
  &.visible{
    transform: scaleY(1);
    width: 440px;
  }
`

export const DropHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  padding: 12px 16px;
  font-family: Manrope, sans-serif;
`

export const MarkAsRead = styled.div`
  color: #0039BB;
  font-size: 14px;
  font-weight: 400;
  font-family: OpenSans, sans-serif;
  cursor: pointer;
`

export const NotificationList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`

export const NotificationItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 18px 22px 16px;
  font-weight: 600;
  font-size: 14px;
  line-height: 25px;
  
  &:hover{
    background-color: #EAF4FCB2;
  }
  &.read{
    font-weight: 400;
  }
  & .highlight {
    color: #EB5757;
    word-break: break-all;
  }
  & img {
    padding-top: 8px;
  }
`

export const NotificationItemDivider = styled.li`
  margin-left: 12px;
  border-bottom: 1px solid rgba(33, 33, 33, 0.08);
`

export const NotificationMessage = styled.div`
  padding-left: 15px;
  flex: 1;
`

export const NotificationRead = styled.div`
  padding-left: 8px;
  padding-top: 8px;
  min-width: 10px;
`

export const ActionButton = styled(Link)`
  font-family: Manrope, sans-serif;
  font-weight: 600;
  font-size: 12px;
  background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%) ;
  border-radius: 4px;
  border-width: 0;
  margin-top: 10px;
  display: inline-block;
  padding: .375rem .75rem;
  line-height: 1.5;
  color: #fff;
  &:hover{
    text-decoration: none;
    color: #fff;
  }
`
export const EmptyContainer = styled.div`
  text-align: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
  padding-top: 30px;
  padding-bottom: 30px;
`
export const EmptyImage = styled.img`
  height: 154px;
  width: auto;
  margin-bottom: 30px;
`
